/** YYYY-MM-DD in the browser's local time zone. */
export const localISODate = (d: Date = new Date()) => d.toLocaleDateString('sv');

/**
 * from/to query params covering whole local days: [fromISO 00:00, day after toISO 00:00).
 * Date arithmetic is done on local midnights so DST-change days stay whole.
 */
export function dayRangeParams(fromISO: string, toISO: string = fromISO): URLSearchParams {
  const from = new Date(`${fromISO}T00:00:00`);
  const after = new Date(`${toISO}T00:00:00`);
  after.setDate(after.getDate() + 1);
  return new URLSearchParams({ from: from.toISOString(), to: after.toISOString() });
}
